import { render, staticRenderFns } from "./FormIndex.vue?vue&type=template&id=42892a9e&scoped=true"
import script from "./FormIndex.vue?vue&type=script&lang=js"
export * from "./FormIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42892a9e",
  null
  
)

export default component.exports